import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getPropertiesQuery($orgId:ID!) {
    authorizedSuborgs(orgId:$orgId) {
      id
      name
      propertyLogoUrl
      propertyManagerLogoUrl
    }
  }
`;
